<template>
  <ul class="news-filter__posts" ref="posts">
    <li class="news-filter__post" v-for="post in convertPosts" :key="post.id">
      <router-link :to="post.link" class="news-filter__post_image">
        <div class="news-filter__post_wrapper">
          <img :src="post.img" alt/>
          <router-link v-if="post.sub_category" to="/" v-text="post.sub_category.name" class="post-sub-cat"
                       :style="{backgroundColor:post.sub_category.color}">
          </router-link>
        </div>

      </router-link>
      <div class="news-filter__post_content">
        <router-link :to="post.link" class="news-post__title" v-text="post.title"/>

        <div class="post-breadcrumbs">
          <router-link
              v-if="post.category"
              :to="post.linkCat"
              class="post-breadcrumb"
              v-text="post.category"
          />

          <a
              v-if="post.modelLink && post.model"
              :href="post.modelLink"
              target="_blank"
              rel="noopener noreferrer"
              class="post-breadcrumb"
              v-text="post.model"
          />
          <span v-if="post.date" class="post-breadcrumb" v-text="post.date"/>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
// Helpers
import convertDate from "@/helpers/convertDate";
import convertCategory from "@/helpers/convertCategory";
import getBlogImg from "@/helpers/getBlogImg";

// Routes Names
import {blog} from "@/staticData/routesName/blog";
import scroll from "@/helpers/scroll";
import {mapState} from "vuex";

export default {
  props: {
    posts: {
      type: Array,
      default: () => []
    },
    selectedFilter: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    scrollElem: null
    // limitPosts: 10
  }),
  methods: {
    showMorePosts() {
      const el = this.$refs.posts;

      if (this.isApp && this.$device.ios()) {
        let offsetTop = -document.querySelector('body.ios.app #main .section-last-added-posts').getBoundingClientRect().top + 90;

        if (offsetTop > el.offsetHeight) {
          this.$emit('getLimitPosts');
        }
      } else {
        if (
            el.offsetTop + el.offsetHeight <
            window.scrollY + window.innerHeight
        ) {
          // this.limitPosts += 10;
          this.$emit('getLimitPosts')
        }
      }
    }
  },
  computed: {
    ...mapState([
      'isApp'
    ]),
    filteredList() {
      return this.posts;
      // const hasFilter = Object.keys(this.selectedFilter).length;
      // return hasFilter
      //   ? this.posts.filter(
      //       item => item && item.filter_id == this.selectedFilter.id
      //     )
      //   : this.posts;
    },
    convertPosts() {
      const posts = this.filteredList.map(post => {
        const category = convertCategory(post.category_id);
        const linkCat = `${blog}/${category.url}`;
        let model = "";
        let modelLink = "";

        if (post.car) {
          const modelBrand = post.car.brand + " ";
          const modelClass = post.car.model_class + " ";
          const modelName = post.car.model_name;
          model = modelBrand + modelClass + modelName;
          modelLink = post.car.model_page;
        }

        const cat = post.tags && post.tags.filter(e => e.is_category === 2);

        return {
          id: post.id,
          title: post.title,
          description: post.description,
          img: getBlogImg(post.img && post.img.file_name),
          slug: post.slug,
          category: category.title,
          linkCat,
          link: `${linkCat}/${post.id}`,
          filter: post.filter,
          date: convertDate(post.created),
          model,
          modelLink,
          sub_category: cat && cat.length === 1 ? cat[0] : null
        };
      });

      return posts/* .reverse() *//* .slice(0, this.limitPosts) */;
    }
  },
  mounted() {
    this.scrollElem = this.$device.ios()
        ? document.querySelector('body.ios #main > :nth-child(2)')
        : window;

    console.log("this.scrollElem ", this.scrollElem);

    //window.onscroll = () => this.showMorePosts();
    this.scrollElem.onscroll = () => this.showMorePosts();
  }
};
</script>